import { finalize } from 'rxjs/operators';
import { Component, AfterContentInit, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { PlycaDataService } from '../../../services/plyca.service';
import { ReportDTO } from '../../api/plyca-dtos-v2';
import { UIService } from '../../ui.service';
import { BaseComponent } from '../common/baseComponent/base.component';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';


@Component({
  selector: 'searchReport',
  templateUrl: 'searchReport.template.html',
  providers: [DialogService, UIService]
})
export class searchReportComponent extends BaseComponent implements AfterContentInit, OnInit {

  filterText = '';
  MIN_SEARCH_TEXT_LENGHT = 3;
  showHeader = true;

  loading = false;
  reportList: ReportDTO[];
  filteredReportList: ReportDTO[];

  constructor(
    private plycaService: PlycaDataService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public waitService: WaitLoadingService
  ) {
    super();
  }
  ngOnInit(): void {
    this.waitService.startWaiting();
    this.loadData();
  }

  ngAfterContentInit(): void {

  }

  loadData() {
    this.loading = true;
    this.subscribe(this.plycaService.getPentahoReport().pipe(finalize(() => this.waitService.cancelWaiting())), (datos: any) => {
      this.reportList = datos.content;
      this.filteredReportList = datos.content;
      this.loading = false;

    });

  }


  isLoading(): boolean {
    return this.loading;
  }

  cancel(): void {
    this.ref.close();
  }

  selectReport(report: ReportDTO) {
    if (report) {
      console.log('report', report.name);
      this.ref.close(report.name);
    }
  }

  public updateFilter() {
    let val: string = this.filterText;
    this.filteredReportList = this.reportList.filter(function (d: any) {
      let reportDesc = d.name;
      return reportDesc.toLowerCase().indexOf(val.toLowerCase()) !== -1 || !val;
    });

  }



}
